import { GTMEvent } from '../GTM'
import { formatCheckoutActionField } from './pushCheckoutStep'

export const pushCheckoutOption = (data: Record<string, unknown>): GTMEvent => {
    return {
        event: 'checkoutOption',
        ecommerce: {
            checkout_option: {
                actionField: formatCheckoutActionField(data)
            }
        },
        _clear: true
    }
}
